<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">갤러리 작성</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">작성자</label>
          <div class="col-sm-4">
            <el-select :disabled="isAll" class="select-primary" size="large" placeholder="작성자" v-model="userId">
              <el-option v-for="option in authorOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
          <base-checkbox v-model="isAll" inline>전체 </base-checkbox>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">커버 이미지</label>
          <div class="col-sm-4">
            <BlipFileUploadZone :upload-category="2" :maxFiles="1" :fileUrl="coverImageUrl" @onChangeFileIds="onFileIdChange" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">타이틀</label>
          <div class="col-sm-4">
            <base-input placeholder="타이틀" v-model="title">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">멤버</label>
          <div class="col-sm-4">
            <el-select :disabled="isAll" multiple class="select-primary" size="large" placeholder="멤버선택" v-model="members.members">
              <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">태그</label>
          <div class="col-sm-4">
            <base-input placeholder="태그" v-model="tags">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">미디어 추가</label>
          <div class="col-sm-4">
            <base-button @click="addMedia" type="success">+</base-button>
          </div>
        </div>
        <div class="row" v-for="(media, index) in medias">
          <div class="col-sm-12">
            <span v-for="(n, index) in mediaTypes" :key="index">
              <base-radio :name="n.type" inline v-model="media.mediaType">{{ n.name }}</base-radio>
            </span>
            <base-button @click="removeMedia(index)" type="default">-</base-button>
          </div>
          <div v-if="media.mediaType === 'I'" class="col-sm-12">
            <div class="row">
              <label class="col-sm-2 col-form-label">이미지</label>
              <div class="col-sm-4">
                <BlipFileUploadZone :upload-category="2" :index="index" :maxFiles="1" :fileUrl="media.imageFileUrl" @onChangeFileIds="onMediaFileIdChange" />
              </div>
              <label class="col-sm-2 col-form-label">설명</label>
              <div class="col-sm-4">
                <base-input placeholder="설명">
                  <textarea class="form-control" rows="30" v-model="media.description" />
                </base-input>
              </div>
            </div>
          </div>
          <div v-if="media.mediaType === 'V'" class="col-sm-12">
            <div class="row">
              <label class="col-sm-2 col-form-label">이미지</label>
              <div class="col-sm-4">
                <BlipFileUploadZone :upload-category="2" :index="index" :maxFiles="1" :fileUrl="media.imageFileUrl" @onChangeFileIds="onMediaFileIdChange" />
              </div>
              <label class="col-sm-2 col-form-label">설명</label>
              <div class="col-sm-4">
                <base-input placeholder="설명">
                  <textarea class="form-control" rows="30" v-model="media.description" />
                </base-input>
              </div>
              <label class="col-sm-2 col-form-label">주소</label>
              <div class="col-sm-4">
                <base-input placeholder="주소" v-model="media.path">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <label class="col-sm-2 col-form-label">타이틀</label>
              <div class="col-sm-4">
                <base-input placeholder="타이틀" v-model="media.title">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
              <label class="col-sm-2 col-form-label">재생시간</label>
              <div class="col-sm-4">
                <base-input placeholder="재생시간" v-model="media.duration">
                  <span slot="helpBlock" class="form-text" />
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";

import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import Endpoints from "@/common/Endpoints";

export default {
  components: {
    Card,
    BaseInput,
    BlipFileUploadZone,
  },
  async created() {
    if (!this.$route.query.unitId) {
      window.Toast.error("잘못된접근입니다");
      history.go(-1);
    }
    this.unitId = Number(this.$route.query.unitId);
    await this.getArtistUnits();
    await this.getArtistMembers();
    await this.getDummyAuthors(this.unitId);
  },
  data() {
    return {
      unitId: null,
      userId: null,
      isAll: false,
      authorOptions: [],
      mediaTypes: [
        { type: "I", name: "이미지" },
        { type: "V", name: "비디오" },
      ],
      title: null,
      tags: null,
      coverImageUrl: null,
      coverFileId: null,
      medias: [],
      members: {
        members: [],
        options: [],
      },
    };
  },
  watch: {
    isAll() {
      if (this.isAll) {
        this.userId = Endpoints.blipUserId;
        this.members.members = [];
      }
    },
  },
  methods: {
    async getDummyAuthors(unitId) {
      try {
        const dummyUsers = await this.$axios.get(`/artistUnit/${unitId}/dummyUsers`);
        const contentAdmins = await this.$axios.get(`/artistUnit/${unitId}/contentAdmins`);

        this.dummyAuthors = dummyUsers.data.data.users.concat(contentAdmins.data.data.users);

        this.authorOptions = [
          ...this.dummyAuthors
            .filter((author) => author.id !== this.userId)
            .map((author) => ({
              label: `${author.nickname}(${author.id})`,
              value: author.id,
            })),
        ];
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async getArtistUnits() {
      return this.$axios.get(`/artistUnit/${this.unitId}`, null).then((res) => {
        const data = res.data.data;
        if (data.isGroup === 1) {
          this.members.options.push({ label: data.blipName, value: data.artistId });
        }
      });
    },
    async getArtistMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;
        if (data.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName ? item.blipName : item.name;
            option.value = item.artistId;
            this.members.options.push(option);
          });
        }
      });
    },
    addMedia() {
      this.medias.push({ mediaType: "I" });
    },
    removeMedia(index) {
      if (index !== -1) {
        this.medias.splice(index, 1);
      }
    },
    async getData() {
      this.imageFileId = null;
      this.imageFileUrl = null;
      this.url = null;
      this.isVisible = false;
      return this.$axios.get(`/dashboard/${this.unitId}/link`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.imageFileId = data.imageFileId;
          this.url = data.url;
          this.width = data.width;
          this.height = data.height;
          this.isVisible = data.isVisible === 1;
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
        }
      });
    },

    onFileIdChange(newFileIds) {
      this.coverFileId = newFileIds[0];
    },

    onMediaFileIdChange(newFileIds, index) {
      this.medias[index].imageFileId = newFileIds[0];
    },

    async onSubmit() {
      if (!this.unitId) {
        window.Toast.error("잘못된 접근입니다.");
        return;
      }
      if (!this.coverFileId) {
        window.Toast.error("커버 이미지를 등록해주세요");
        return;
      }
      if (this.medias.length === 0) {
        window.Toast.error("미디어를 등록해주세요");
        return;
      }
      if (!this.title) {
        window.Toast.error("타이틀을 입력해주세요");
        return;
      }
      const param = {
        unitId: this.unitId,
        userId: this.userId,
        artistIds: this.members.members,
        title: this.title,
        coverImage: { fileId: this.coverFileId },
        tags: [],
        medias: this.medias.map((media) => {
          if (media.mediaType === "V") {
            media.source = { title: media.title, sourceId: 6 };
          }
          media.image = {
            fileId: media.imageFileId,
          };
          return media;
        }),
      };
      let tags = [];
      if (this.tags !== null && this.tags !== "") {
        tags = this.tags.split(",");
      } else {
        window.Toast.error("태그를 제대로 입력해 주세요");
        return;
      }
      for (const tag of tags) {
        if (!tag || tag.trim() === "") {
          window.Toast.error("태그를 제대로 입력해 주세요");
          return;
        }
        param.tags.push(tag.trim());
      }
      const url = this.isAll ? `/collection` : `/collection/${this.unitId}`;
      await this.$axios
        .post(url, param)
        .then((res) => {
          window.Toast.success("등록되었습니다");
          this.$router.go(-1);
        })
        .catch((error) => {
          console.log(error.response);
          window.Toast.error(error.response.data.error.message);
        });
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
